import { SvgIcon } from './SvgIcon.jsx';

const id = 'chevron-icon';

// No `stroke-width` here, so each `<use>` can set its own and have it inherited.
export const ChevronIconSymbol = () => (
	<symbol id={id} viewBox="0 0 16 16">
		<polyline fill="none" stroke="currentColor" points="15,11 8,5 1,11" />
	</symbol>
);

/**
 * @param {Object} props
 * @param {number} [props.strokeWidth=2] In the icon's 16-unit viewBox, so it renders at
 *   `strokeWidth * size / 16` px
 */
export const ChevronIcon = ({ className, size = '24', hidden = false, strokeWidth = 2 }) => (
	<SvgIcon className={className} width={size} height={size} hidden={hidden}>
		<use xlinkHref={`#${id}`} strokeWidth={strokeWidth} />
	</SvgIcon>
);
